import focusLock from 'dom-focus-lock';

import { cartModel } from 'assets/components';

import './header.scss';

const SELECTOR_HEADER = '.js-header';
const SELECTOR_CART = '.js-headerCart';
const SELECTOR_NAV = '.js-nav';
const SELECTOR_TOGGLE = '.js-navToggle';

const INITIAL_STATE = {
  isOpen: false,
};

let state = { ...INITIAL_STATE };

const renderOpenState = function renderHeaderOpenState(isOpen) {
  const elToggle = document.querySelector(SELECTOR_TOGGLE);
  const elNav = document.querySelector(SELECTOR_NAV);
  elToggle.setAttribute(
    'aria-expanded',
    isOpen ? 'true' : 'fase',
  );
  elToggle.setAttribute(
    'aria-label',
    isOpen ? 'Open Navigation' : 'Close Navigation',
  );
  elNav.classList[isOpen ? 'add' : 'remove']('is-open');

  // Control focus
  // Focus on the 1st item
  if (isOpen) {
    focusLock.on(elNav.parentNode);
    elNav.querySelector('a').focus();
  } else {
    focusLock.off(elNav.parentNode);
    elToggle.focus();
  }
};

const setState = function setHeaderState(newState = {}) {
  if (newState.isOpen !== state.isOpen) {
    renderOpenState(newState.isOpen);
  }

  state = {
    ...state,
    ...newState,
  };
};

const getHeight = function getHeaderHeight() {
  return window.matchMedia('(max-width: 1023px)').matches
    ? 70
    : 94;
};

const onToggle = function onHeaderToggle() {
  setState({
    isOpen: !state.isOpen,
  });
};

const close = function closeHeader() {
  setState({
    isOpen: false,
  });
};

const show = function showHeader() {
  document.querySelector(SELECTOR_HEADER).classList.remove('is-hidden');
  document.querySelector(SELECTOR_HEADER).classList.remove('is-hidden-mobile');
};

const hide = function hideHeader(props = {}) {
  document.querySelector(SELECTOR_HEADER).classList.add('is-hidden');
  if (props.shouldIncludeMobile) {
    document.querySelector(SELECTOR_HEADER).classList.add('is-hidden-mobile');
  }
};

const renderCart = function renderHeaderCart(data) {
  const cartEl = document.querySelector(SELECTOR_CART);
  // console.log('CART');
  // console.log(data);

  if (cartEl) {
    cartEl.setAttribute('data-items', data.item_count);
  }

  if (data?.items) {
    data.items.forEach((item) => {
      if (item?.product_type === 'trial') {
        // console.log('TRIAL');
        document.querySelectorAll('.js-productInfoAddTrial').forEach((el) => {
          el.setAttribute('disabled', true);

          setTimeout(() => {
            if (el) {
              el.innerHTML = 'Already In Cart';
            }
          }, 3000);
        });
      }
    });
  }
};

const init = function initHeader() {
  document.querySelector(SELECTOR_TOGGLE).addEventListener('click', onToggle);

  cartModel.addCallback(renderCart);
};

export default {
  close,
  getHeight,
  hide,
  init,
  show,
};
